import { useState } from "react";

export const useToken = () => {
  const [tokenInternal, setTokenInternal] = useState(
    sessionStorage.getItem("token")
  );

  const setToken = (newToken) => {
    sessionStorage.setItem("token", newToken);
    setTokenInternal(newToken);
  };

  return [tokenInternal, setToken];
};
